import * as autoBind from "auto-bind";
import * as React from "react";
import LoadObject from "../../../load_objects/LoadObject";
import { ILogin } from "../../../login/records/Login";
import "./changepassword.css"
export interface IChangePasswordViewProps
{
    loginLoader: LoadObject<ILogin>;
    onChangePassword: (newPassword: string) => void;
}

export interface IChangePasswordViewState
{
    newPassword: string;
    retypedPassword: string;
    sentPasswordChangeRequest: boolean;
}

export default class ChangePasswordView extends React.Component<IChangePasswordViewProps, IChangePasswordViewState> {

    constructor(props: any)
    {
        super(props);
        autoBind.react(this);

        this.state = {
            newPassword: "",
            retypedPassword: "",
            sentPasswordChangeRequest: false
        };
    }

    public render()
    {
        const loginLoader = this.props.loginLoader;

        if (this.state.sentPasswordChangeRequest) {
            if (loginLoader.hasError()) {
                this.showAlertBox("Error changing password, please contact support");
            } else {
                const loaderState = loginLoader.getValue();
                const passwordChanged = loaderState?.passwordChanged;
    
                if (passwordChanged) {
                    this.showAlertBox("Password changed successfully!");
                }
            }
        }

        const newPassword = this.state.newPassword;
        const retypedPassword = this.state.retypedPassword;

        return (
            <div className="changePasswordBox">
                <section className={"loginWrap"}>
                    <h2 className="loginHead">Change Password</h2>

                    <section className="inputWrapper">
                        <label className="inputLabel">New Password</label>
                        <input
                            className="inputFieldCPW"
                            type="password"
                            onKeyPress={this.handleKeyPress}
                            onChange={this.onNewPasswordChange}
                            value={newPassword} />
                    </section>

                    <section className="inputWrapper">
                        <label className="inputLabel">Re-type new password</label>
                        <input
                            className="inputFieldCPW"
                            type="password"
                            onKeyPress={this.handleKeyPress}
                            onChange={this.onRetypePasswordChange}
                            value={retypedPassword} />
                    </section>

                    <section className="alertBox hidden" id="alertBox"></section>

                    <section className="inputWrapper">
                        <button className="loginButton" onClick={this.doChangePassword}>Change Password</button>
                    </section>
                    
                    {/*<section className="signUp-linker"> Or <Link to="/signup" className="href">sign up</Link></section>*/}
                </section>
            </div>
        );
    }

    private onStateChanged(changes)
    {
        const newState = {
            newPassword: changes.newPassword || this.state.newPassword,
            retypedPassword: changes.retypedPassword || this.state.retypedPassword
        };

        if (changes.newPassword === "")
        {
            newState.newPassword = "";
        }
        if (changes.retypedPassword === "")
        {
            newState.retypedPassword = "";
        }

        this.setState(newState);
    }

    private doChangePassword()
    {
        const newPassword = this.state.newPassword;
        const retypedPassword = this.state.retypedPassword;

        if (!newPassword)
        {
            this.showAlertBox("Please enter a new password");
            return;
        }
        else if (!retypedPassword)
        {
            this.showAlertBox("Please re-type the password");
            return;
        }
        else if (newPassword.length < 8) 
        {
            this.showAlertBox("Password must be at least 8 characters long");
            return;
        }
        else if (newPassword !== retypedPassword)
        {
            this.showAlertBox("Re-typed password did not match new password");
            return;
        }
        else
        {
            this.hideAlertBox();
        }

        const newState = {
            newPassword: newPassword,
            retypedPassword: retypedPassword,
            sentPasswordChangeRequest: true
        };
        this.setState(newState);
        this.props.onChangePassword(newPassword);
    }

    private showAlertBox(warning)
    {
        const alertBox = document.getElementById("alertBox")!;
        if (alertBox != null) {
            alertBox.innerHTML = warning;
            alertBox.classList.remove("hidden");
        }
    }

    private hideAlertBox()
    {
        const alertBox = document.getElementById("alertBox")!;
        alertBox.classList.add("hidden");
    }

    private onNewPasswordChange(evt)
    {
        this.onStateChanged({ newPassword: evt.target.value });
    }

    private onRetypePasswordChange(evt)
    {
        this.onStateChanged({ retypedPassword: evt.target.value });
    }

    private handleKeyPress(evt)
    {
        if (evt.charCode === 13)
        {
            this.doChangePassword();
            return true;
        }

        return false;
    }
}
